<script setup>
import { ref } from "vue";
const props = defineProps({
    section: {
        type: Object,
        required: true,

    },

});
const subCats = ref(false);

</script>

<template>

    <v-menu v-model="subCats" :close-on-content-click="true" location="bottom" open-on-hover>
        <template v-slot:activator="{ props }">


            <Link :href="route('category', section.slug)">
                
                <v-card @click="router.visit(section.url)"
                class=" text-center hover:shadow-2xl hover:scale-105 bg-cover bg-center transition-all duration-300 cursor-pointer "
                style="padding: 0px!important;">
                <div class="flex flex-col h-full justify-center ">
                    <img :src="section.thumb_file?.media_url" class="w-full h-full object-cover " />
                    <div class="text-lg font-semibold py-4 bg-primary">
                        <Link :href="section.url"
                            class="text-decoration-none text-white dark:text-white hover:text-white dark:hover:text-white">
                        {{ section.title }}
                        </Link>
                    </div>
                </div>
            </v-card>
            <!-- <v-card class="flex items-center justify-center h-20 bg-top bg-no-repeat bg-cover border md:h-24 w-fu ll text-secondary dark:text-white hover:bg-primary hover:text-white" v-bind="props"
                style="background-image: url('/assets/patterns/cat.webp')">
                <div class=" text-[14px] md:text-[16px] font-bold">
                    {{ section.title }}
                </div>
            </v-card> -->
            </Link>
        </template>

        <!-- <v-card class="mt-2 overflow-hidden border rounded-lg" v-if="section.children?.length > 0">
            <v-row class="overflow-hidden " >
                <v-col v-for="children in section.children" :key="children" class="flex items-center justify-center h-20 p-5 bg-top bg-no-repeat bg-cover border dark:text-white hover:bg-primary hover:text-white md:h-28 w-60"
                    style="background-image: url('/assets/patterns/cat.webp')">
                    <Link :href="route('category', children.slug)">
                    <div class="p-8">
                        {{ children.title }}
                    </div>
                    </Link>

                </v-col>

              
            </v-row>
        </v-card> -->
    </v-menu>

</template>
